<template>
    <v-container fluid class="pa-0">
        <v-row dense>
            <v-col cols="3">
                <v-card color="grey darken-2" v-for="(item, index) in topTen" :key="index">
                    <v-card-text class="pa-1 mt-1">
                        <v-chip color="grey darken-3" label small>{{index+1}}</v-chip>
                        <v-tooltip color="primary" top>
                            <template v-slot:activator="{ on }">
                                <span class="pl-2" v-on="on">
                                    {{item.keyword}}
                                </span>
                            </template>
                            {{item.keyword}} count: {{item.count}}
                        </v-tooltip>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="9">

                <!-- CHART -->
                <div class="chart" ref="chartdiv"></div>
            </v-col>

        </v-row>
    </v-container>
</template>

<script>

    import {mapActions} from 'vuex';
    import StatBox from '../../../../components/UI/StatBoxNumerical';
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4plugins_wordCloud from "@amcharts/amcharts4/plugins/wordCloud";

    export default {

        components: {
            StatBox
        },

        props: {
            dataVariable: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                statsLoading: false,
                stats: {
                    avg: 0,
                    min: 0,
                    max: 0,
                    std_deviation: 0,
                    std_deviation_bounds: {
                        upper: 0,
                        lower: 0,
                    },
                    variance: 0,
                    sum: 0
                },
                boxColor: 'blue-grey darken-1'
            }
        },

        computed: {
            topTen() {
                if (!this.stats.frequencies) return [];
                return this.stats.frequencies.slice(0, 10);
            }
        },

        mounted() {

            this.statsLoading = true;

            this.getDataVariableStats(this.dataVariable.id)
                .then(data => {
                    this.stats = data.stats;

                    this.createChart();
                })
                .catch(() => {
                    Bus.$emit('flash-message', {
                        type: 'error',
                        message: 'Failed loading stored data count for the option!'
                    });
                })
                .finally(() => {
                    this.statsLoading = false;
                });
        },

        methods: {

            // Root actions
            ...mapActions([
                'getDataVariableStats'
            ]),

            createChart() {
                let chart = am4core.create(this.$refs.chartdiv, am4plugins_wordCloud.WordCloud);

                let series = chart.series.push(new am4plugins_wordCloud.WordCloudSeries());

                series.maxCount = 100;
                series.minWordLength = 2;
                series.accuracy = 4;
                series.step = 15;
                series.rotationThreshold = 0.7;
                series.labels.template.tooltipText = "{word}: {value}";
                series.fontFamily = "Courier New";
                series.maxFontSize = am4core.percent(30);

                series.heatRules.push({
                    "target": series.labels.template,
                    "property": "fill",
                    "min": am4core.color("#329EF4"),
                    "max": am4core.color("#ff5555"),
                    "dataField": "value"
                });

                series.dataFields.word = 'keyword';
                series.dataFields.value = 'count';

                series.data = this.stats.frequencies;
            },


        }
    }
</script>
